import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { ToastController } from '@ionic/angular';
import { interval } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  constructor(private swUpdate: SwUpdate,  private toastController: ToastController) {
    if (swUpdate.isEnabled) {
      interval(15 * 1000).subscribe(() => swUpdate.checkForUpdate()
      .then(() => console.log('checking for updates')));
    }
  }

  public checkAvailability() {
    if (this.swUpdate.isEnabled) {
      console.log('update-checker is enabled.');
      this.checkForUpdates();
    } else {
      console.log('update-checker is disabled!');
    }
  }

  public checkForUpdates(): void {
    console.log('update-checker is subscribed.');
    this.swUpdate.available.subscribe(() => this.promptUser());
  }

  private promptUser(): void {
    console.log('Update found.');
    this.toastController.create({
      message: 'Update verfügbar.',
      color: 'danger',
      buttons: [
        {
          text: 'Ok',
          icon: 'refresh',
          role: 'cancel'
        }
      ],
      position: 'middle'
    }).then((el) => {
      el.onDidDismiss().then(() => {
        window.location.reload();
      });
      el.present();
    });
  }
}
